import { Tag, TagLabel, TagLeftIcon, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { FaCheckCircle, FaPen } from 'react-icons/fa';

function PublishTag({ isPublished, ...rest }) {
  return (
    <Tooltip
      {...rest}
      label={
        isPublished
          ? 'Published: Ready for access'
          : 'Draft: Still in editing mode'
      }
    >
      <Tag
        size="sm"
        colorScheme={isPublished ? 'green' : 'blue'}
        variant="solid"
      >
        <TagLeftIcon as={isPublished ? FaCheckCircle : FaPen} />
        <TagLabel>{isPublished ? 'Published' : 'Draft'}</TagLabel>
      </Tag>
    </Tooltip>
  );
}

PublishTag.defaultProps = {
  isPublished: false,
};

PublishTag.propTypes = {
  isPublished: PropTypes.bool,
};

export default PublishTag;
